import { Alignment, Navbar, Button } from "@blueprintjs/core";
import React from 'react';
import { Link, Outlet } from "react-router-dom";

export default function Root() {
  return (
    <>
      <Navbar>
        <Navbar.Group align={Alignment.LEFT}>
          <Link to='/'><Button className="bp5-minimal" icon="timeline-events" text="Daily" /></Link>
          <Link to='/adventure'><Button className="bp5-minimal" icon="flag" text="Adventure" /></Link>
          <Link to='/unlimited'><Button className="bp5-minimal" icon="repeat" text="Unlimited" /></Link>
        </Navbar.Group>
      </Navbar>
      <Outlet />
    </>
  );
}